import { motion } from 'framer-motion';
import { KeyRound, Navigation, Smartphone, Webcam } from 'lucide-react';
import { Section, SectionTitle } from '@/components/landing/Section';

const FEATURES = [
  {
    icon: Webcam,
    title: 'Monitoreo 24/7',
    text: 'Central de videovigilancia con verificación de eventos en tiempo real.',
  },
  {
    icon: Smartphone,
    title: 'App Móvil',
    text: 'Controlá tu seguridad y recibí alertas desde tu teléfono.',
  },
  {
    icon: Navigation,
    title: 'GPS Vehicular',
    text: 'Seguimiento de flota y rondas con geolocalización en vivo.',
  },
  {
    icon: KeyRound,
    title: 'Control de Acceso',
    text: 'Gestión inteligente de ingresos con credenciales y biometría.',
  },
];

export function Futuro() {
  return (
    <Section id="futuro">
      <SectionTitle subtitle="Innovación continua para anticiparnos a las amenazas del mañana.">
        Lo que viene
      </SectionTitle>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {FEATURES.map((f, i) => {
          const Icon = f.icon;
          return (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              whileHover={{ y: -4 }}
              className="relative rounded-2xl border border-white/[0.06] bg-white/[0.02] p-6 transition-colors hover:bg-white/[0.04]"
            >
              <span className="absolute right-4 top-4 rounded-full border border-white/[0.08] bg-white/[0.02] px-2 py-0.5 font-mono text-[10px] uppercase text-slate-400">
                Próximamente
              </span>
              <Icon className="h-9 w-9 text-primary" strokeWidth={1.5} aria-hidden />
              <h3 className="mt-4 text-lg font-semibold">{f.title}</h3>
              <p className="mt-2 text-sm text-slate-400">{f.text}</p>
            </motion.div>
          );
        })}
      </div>
    </Section>
  );
}
